import type { MasteryDashboardView } from '../model/types/mastery-map-dashboard/interfaces'

export const DEFAULT_DASHBOARD_VIEW: MasteryDashboardView = {
  selection: null,
  tab: 'skill-balance',
  status: 'all',
  expanded: [],
}
